
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

interface LogoProps {
  className?: string;
  compact?: boolean;
}

export const Logo = ({ className = "", compact = false }: LogoProps) => {
  const isMobile = useIsMobile();
  
  return (
    <Link to="/" className={`flex items-center ${className}`}>
      <div className="flex flex-col">
        {compact ? (
          <span className="font-league-spartan font-bold text-2xl tracking-tight text-primary leading-none">L.</span>
        ) : (
          <>
            <span className={`font-league-spartan font-bold tracking-tight text-primary leading-none text-right ${isMobile ? 'text-[1.8rem]' : 'text-[2.5rem]'}`}>
              loaded.
            </span>
            <span className="text-[0.6rem] uppercase tracking-wider text-primary/80 font-league-spartan -mt-1 text-right font-bold">
              CAREER
            </span>
          </>
        )}
      </div>
    </Link>
  );
};
